const React = require('react');
const ButtonAccept = require('../../dumb/Button/Accept');
const Base = require('../../smart/Page/AuthLayout');
const {Link} = require("../../../router");
const {LINK_TFA_VERIFICATION} = require("../../../constants/links");
const {cachedAccount$} = require("../../../emitters/account");

module.exports = () => {
  return (
    <Base
      cachedAccount={cachedAccount$.getValue()}
      title="Reset security verification"
      content={(
        <div className="f15 fw4 tl c0 mt-55 mb-45">
          <span className="fwB">
            I lost my Google 2FA reset code, how can I get it back?
          </span>
          <br/><br/>

          I can access a device that was set up with the Google 2FA reset code.
          <br/><br/>

          We suggest you disable Google Authenticator on your Lunu account first,
          then enable it again using your new device. Remember to save your
          reset code this time.
          <br/><br/>

          <span className="fwB">
            I can&apos;t access a device that was set up with the Google 2FA
            reset code
          </span>
          <br/><br/>

          Please confirm request to our Support to get a new code.
        </div>
      )}
      control={(
        <ButtonAccept
          className="w"
          href="mailto:support@lunu.io"
        >
          Confirm request
        </ButtonAccept>
      )}
      additional={(
        <div className="f12 fw3 lh lts0em">
          <Link
            href={LINK_TFA_VERIFICATION}
            className="c5B47FF olN tdU dn f12 fw3 o70:h"
          >Back to verification</Link>
        </div>
      )}
    />
  )
};
